import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import {
  CSV_FILE_PATH,
  CSV_FILE_PATH_WITH_AUTOMATED_CALL,
} from '../../constants'
import { usePlace } from 'commons/usePlace'
import { tableDesc } from './constants'

export default (props) => {
  const {
    classes,
    toggleDialogs,
    VIEW_VALID_CSV_FORMAT,
    CSVNewSampleFilePath,
  } = props
  const place = usePlace()

  const simpleCSVPath =
    CSVNewSampleFilePath ||
    (place.enabledAutomatedCall
      ? CSV_FILE_PATH_WITH_AUTOMATED_CALL
      : CSV_FILE_PATH)

  return (
    <Dialog
      open={true}
      maxWidth={place.enabledAutomatedCall ? 'lg' : 'md'}
      fullWidth={true}
      className={classes.groupDialog}
    >
      <DialogTitle>
        <p className={classes.dialogViewCSVTitle}>
          <FormattedMessage id="subscriber.dialog.howToImport.CSV.title" />
        </p>
      </DialogTitle>

      <DialogContent className={classes.dialogViewValidContentTwo}>
        <div className={classes.dialogViewValidWrapp}>
          <p className={classes.dialogViewCSVSubTitle}>
            <FormattedMessage id="subscriber.dialog.howToImport.CSV.subTitle" />
          </p>
          <div className={classes.dialogViewCSVLine} />
        </div>

        <div className="overflow-y-scroll">
          <table className={classes.dialogViewCSVTable}>
            <thead>
              <tr>
                <th className="px-24">first_name</th>
                <th className="px-24">last_name</th>
                <th className="px-24">unique_id</th>
                <th className="px-24">date_of_birth</th>
                <th className="px-24">email</th>
                <th className="px-24">country_code</th>
                <th className="px-24">phone_number</th>
                {place.enabledAutomatedCall ? (
                  <>
                    <th
                      className="px-24 break-words"
                      style={{ maxWidth: '150px' }}
                    >
                      automated_call_country_code
                    </th>
                    <th
                      className="px-24 break-words"
                      style={{ maxWidth: '150px' }}
                    >
                      automated_call_number
                    </th>
                    <th className="px-24">preferred_language</th>
                  </>
                ) : null}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-24">Alan</td>
                <td className="px-24">Smith</td>
                <td className="px-24">UI-225</td>
                <td className="px-24">12/23/1999</td>
                <td className="px-24">smith@example.com</td>
                <td className="px-24">41</td>
                <td className="px-24">12345678</td>
                {place.enabledAutomatedCall ? (
                  <>
                    <td className="px-24">1</td>
                    <td className="px-24">12345678</td>
                    <td className="px-24">en</td>
                  </>
                ) : null}
              </tr>
            </tbody>
          </table>
        </div>

        <div className={classes.dialogViewValidWrapp}>
          <div className={clsx('mt-24', classes.dialogViewValidContentThree)}>
            {tableDesc(place.enabledAutomatedCall, classes).map((list) => (
              // to do Missing "key" prop for element in array
              <tbody>
                <tr>
                  <td
                    className={'py-3 border-b-1 border-gray-200 font-bold pr-5'}
                  >
                    {list.header}
                  </td>
                  <td className={'py-3 border-b-1 border-gray-200'}>
                    {list.desce}
                  </td>
                </tr>
              </tbody>
            ))}

            <br />

            <p className="font-bold">IMPORTANT</p>
            <ul>
              <li>
                <FormattedMessage
                  id="subscriber.dialog.howToImport.CSV.content.note1"
                  values={{
                    b: (text) => <b className={classes.colorOne}>{text}</b>,
                  }}
                />
              </li>
              <li>
                <FormattedMessage id="subscriber.dialog.howToImport.CSV.content.note2" />
              </li>
              {place.enabledAutomatedCall ? (
                <li>
                  <FormattedMessage id="subscriber.dialog.howToImport.CSV.content.note3" />
                </li>
              ) : null}
            </ul>
          </div>
          <div className={classes.dialogViewCSVDownloadBtnWrapp}>
            <Button
              href={simpleCSVPath}
              download
              className={classes.dialogViewCSVDownloadBtn}
            >
              <i className="material-icons">save</i>
              <FormattedMessage id="subscriber.downloadSampleBtn.label" />
            </Button>
          </div>
        </div>
      </DialogContent>

      <DialogActions className={classes.dialogViewCSVActionPanel}>
        <Button
          className={clsx(classes.groupActionBtns)}
          onClick={() => {
            toggleDialogs(VIEW_VALID_CSV_FORMAT, false)
          }}
          variant="contained"
          color="secondary"
        >
          <FormattedMessage id="action.gotIt" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}
